export default __webpack_public_path__ + "static/media/what_we_do_4.6406d7c2.svg";